<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useQuickGuideStateStore } from '@/stores/quickGuideState';

const store = useQuickGuideStateStore();

onMounted(async () => {
  try {
    await store.loadContent();
  } catch (err) {
    console.error('[App.vue] Failed to load content:', err);
  }
});
</script>

<style lang="scss">
@import 'styles/global.scss';

.loading-container,
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 2rem;
}

.loading-content,
.error-content {
  text-align: center;
}

.spinner {
  width: 50px;
  height: 50px;
  margin: 0 auto 1rem;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #0059b3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.error-content {
  max-width: 500px;

  h2 {
    color: #d32f2f;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1.5rem;
    color: #666;
  }

  button {
    margin-top: 1rem;
  }
}
</style>
